import { jsx } from "react/jsx-runtime";
import { createContext, useMemo, useContext } from "react";
import { useFormikContext } from "formik";
const Context = createContext({});
const FormValueProvider = ({ children }) => {
  const { values } = useFormikContext();
  const value = useMemo(() => values, [values]);
  return /* @__PURE__ */ jsx(Context.Provider, { value, children });
};
const useFormValue = () => {
  const context = useContext(Context);
  return context;
};
export {
  FormValueProvider,
  useFormValue
};
